import React, {Component} from "react";
import {CircleMarker, Marker} from 'react-leaflet';
import L from 'leaflet';
import uniq from "lodash/uniq";
import uniqBy from "lodash/uniqBy";
import {connect} from "react-redux";
import {isMobile} from './PureTools';
import {airportToCityCountry, log, normalizeFlight, NullableType} from "./Tools";
import store, {LocationsType, StateBaseType} from "./store";
import * as actions from "./actions/action";
import {CityAndPositionType, FlightAndPositionType, FlightType, LatLngType, SET_HOVERED_CITY} from "./actions/action";
import {AnyAction, bindActionCreators, Dispatch} from "redux";
import LPolyline from "./LPolyline";
import {GOOGLE_MAP_TYPE} from "./Constants";

interface LocalStateType {
}

interface InputType {
    /* from parent */
    setUpdateFlightsAndLocationsFunction: any,
    mapZoom: any,
    setParentForceLineRender: any,
}

interface StateType {
    /* from redux props mapping*/
    locations: LocationsType,
    isFilter: boolean,
    flights: FlightType[],
    hoveredCity: CityAndPositionType,
    hoveredFlight: FlightAndPositionType,
    markerPosition: NullableType<LatLngType>,
    mapType: number,
    mapZoomLeaflet: number
}

interface DispatchType {
    /* from redux actions*/
    setHoveredCity: typeof actions.setHoveredCity,
    setHoveredFlight: typeof actions.setHoveredFlight,
}

type PropsType = InputType & StateType & DispatchType;


class LPolylines extends Component<PropsType, LocalStateType> {

    constructor(props: PropsType) {
        super(props);

        this._circleClick = this._circleClick.bind(this);
        this._circleHover = this._circleHover.bind(this);
        this._circleClear = this._circleClear.bind(this);
        this._forceUpdate = this._forceUpdate.bind(this);
        this._updateParentState = this._updateParentState.bind(this);
        this._getMeasurements = this._getMeasurements.bind(this);
        this._hoverCity = this._hoverCity.bind(this);
        this._setHoverFlight = this._setHoverFlight.bind(this);

        setTimeout(this._updateParentState, 0);

    }

    shouldComponentUpdate(nextProps: Readonly<PropsType>, nextState: Readonly<LocalStateType>, nextContext: any): boolean {
        return (nextProps.mapType !== GOOGLE_MAP_TYPE) &&
            (nextProps.flights !== this.props.flights ||
                nextProps.isFilter !== this.props.isFilter ||
                nextProps.markerPosition !== this.props.markerPosition);
    }

    _getMeasurements() {
        // @ts-ignore
        return document.getElementById('appDiv').getBoundingClientRect();
    }

    _updateParentState() {
        this.props.setParentForceLineRender(this._forceUpdate);
    }

    _forceUpdate() {
        this.forceUpdate();
    }


    _hoverCity(city: any, e: any) {
        // console.log('hovercity', city, e);
        const state = store.getState().reducer;
        // @ts-ignore
        if (state.showCharts > -1 || state.showGlobe > -1 || state.showTableNumber > -1 || state.editFlightNumber > -1 || state.showShowcase) {
            return false;
        }

        this.props.setHoveredCity({
            hoveredCity: city,
            hoveredCityPosition: {
                x: e ? e.containerPoint.x : null,
                y: e ? e.containerPoint.y : null
            }
        });
    }

    _circleClick(city: string) {
        return (e: any) => {
            if (isMobile) {
                log('click', city);
                this._hoverCity(city, e);
            }
        };
    }

    _circleHover(city: string) {
        return (e: any) => {
            this._hoverCity(city, e);
        };
    }

    _circleClear() {
        this._hoverCity(null, null);
    }

    _setHoverFlight(flight: any, e: any) {
        this.props.setHoveredFlight({
                flight: flight,
                hoveredFlightPosition: {
                    x: e ? e.containerPoint.x : null,
                    y: e ? e.containerPoint.y : null
                }
            }
        );
    }

    render() {
        log('renderLPolylines', this.props.flights.length);

        // leaflet does not have mobile onmouseout support -> must be tested at render after the next click
        if (isMobile
            && this.props.hoveredCity.hoveredCity
            && this.props.hoveredFlight.flight) {

            const lastAction = store.getState().lastAction;
            // do not clear if circle was just clicked
            if (lastAction && lastAction.type !== SET_HOVERED_CITY) {
                setTimeout(() => this._circleClear(),0);
            } else {
                setTimeout(() => this._setHoverFlight(null, null),0);
            }
        }

        let marker: any;

        if (this.props.markerPosition) {
            const position = new L.LatLng(this.props.markerPosition.lat, this.props.markerPosition.lng);
            marker =
                <Marker
                    position={position}
                />;
        }

        const circleRadiusBase = isMobile ? 8 : 2;

        return (
            <div>

                {marker}

                {uniqBy(this.props.flights, flight2 => {
                    const flight3 = normalizeFlight(flight2, this.props.locations);
                    return flight3.from + '-' + flight3.to;
                })
                    .map(flight => (
                        <LPolyline
                            key={flight.id}
                            flight={flight}
                        />
                    ))}

                {uniq(this.props.flights
                    .reduce((sum: string[], flight) => sum.concat(flight.from, flight.to), []))
                    .map((airport, index) => (
                        [
                            <CircleMarker
                                key={'left' + index}
                                radius={this.props.mapZoomLeaflet * circleRadiusBase}
                                center={L.latLng(
                                    this.props.locations[airport].lat,
                                    this.props.locations[airport].lng - 360
                                )}
                                fill={true}
                                color={"rgba(0,0,0,0)"}
                                opacity={0}
                                onClick={this._circleClick(airportToCityCountry(airport, this.props.locations))}
                                onMouseOver={this._circleHover(airportToCityCountry(airport, this.props.locations))}
                                onMouseOut={this._circleClear}
                            />,
                            <CircleMarker
                                key={'center' + index}
                                radius={this.props.mapZoomLeaflet * circleRadiusBase}
                                center={L.latLng(
                                    this.props.locations[airport].lat,
                                    this.props.locations[airport].lng
                                )}
                                fill={true}
                                color={"rgba(0,0,0,0)"}
                                opacity={0}
                                onClick={this._circleClick(airportToCityCountry(airport, this.props.locations))}
                                onMouseOver={this._circleHover(airportToCityCountry(airport, this.props.locations))}
                                onMouseOut={this._circleClear}
                            />,
                            <CircleMarker
                                key={'right' + index}
                                radius={this.props.mapZoomLeaflet * circleRadiusBase}
                                center={L.latLng(
                                    this.props.locations[airport].lat,
                                    this.props.locations[airport].lng + 360
                                )}
                                fill={true}
                                color={"rgba(0,0,0,0)"}
                                opacity={0}
                                onClick={this._circleClick(airportToCityCountry(airport, this.props.locations))}
                                onMouseOver={this._circleHover(airportToCityCountry(airport, this.props.locations))}
                                onMouseOut={this._circleClear}
                            />
                        ]
                    ))}

            </div>
        );
    }
}

const mapStateToProps = (state: StateBaseType) => {
    return {
        isFilter: state.reducer.isFilter,
        flights: state.reducer.flights,
        locations: state.reducer.locations,
        hoveredCity: state.reducer.hoveredCity,
        hoveredFlight: state.reducer.hoveredFlight,
        markerPosition: state.reducer.markerPosition,
        mapType: state.reducer.mapType,
        mapZoomLeaflet: state.reducer.mapZoomLeaflet
    }
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators<any, any>(actions, dispatch);
};

export default connect<StateType, DispatchType, InputType, StateBaseType>(mapStateToProps, mapDispatchToProps)(LPolylines);
